import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'Features | Canny';
const Description =
  'A list of the core Canny features. From feedback to feature release, Canny helps your team complete the feedback loop.';
const Image = 'https://canny.io/images/canny-social.png';

export default class LandingFeaturesHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/features' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
